export default __webpack_public_path__ + "static/media/mob-logo.bfaf1237.svg";